import Base from "./Base";

class ListRoles extends Base {
    static getRole(body) {
        return this.sendRequest("/list-roles/get-role", "POST", {}, body);
    }
    static getRoles(body){
        return this.sendRequest("/list-roles/get-roles", "POST", {}, body);
    }
    static updateRole(body){
        return this.sendRequest("/list-roles/update-role","POST", {}, body);
    }
}

export default ListRoles;